import { ReactComponent as InformationIcon } from "@icons/information.svg";
import { PropsWithChildren } from "react";

export default function InfoAlert({ title, children }: { title?: string } & PropsWithChildren) {
  return (
    <div data-testid="info-alert">
      <div
        className="flex flex-col gap-2 border-2 border-[#32A1B3]
     bg-[#D6ECF0] p-4 rounded mb-4"
      >
        <div className="flex items-center gap-2">
          <InformationIcon className="w-5 h-5" />
          <h3 className="!pb-0">{title}</h3>
        </div>
        {children}
      </div>
    </div>
  );
}
